import axios from "axios";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../baseUrl";

const CreatePackage = () => {
  const [packageName, setPackageName] = useState("");
  const [examName, setExamName] = useState("");
  const [payment, setPayment] = useState("");
  const [amount, setAmount] = useState("");
  const [description,setDescription]=useState("")
  const [active,setActive]=useState(true)
  const [message,setMessage]=useState(false)
  const [file,setFile]=useState(null)
  const imgRef=useRef("")

  const data={packageName,examName,payment,amount,description,active}

  const handleFile=(e)=>{
    const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (validFileTypes.includes(e.target.files[0].type) &&
      e.target.files[0].size <= maxSizeInBytes) 
    {
      setFile(e.target.files)
    }
    else{
      setMessage('Invalid file. Only JPEG, JPG, or PNG files under 2MB are allowed.')
      setFile(null);
      imgRef.current.value=""
    }
  }
  const handleSubmit=(e)=>{
    if(!file){
      setMessage('Please select file')
    }
    else{
      const formData=new FormData()
      formData.append('data',JSON.stringify(data))
      for(var i=0;i<file.length;i++){
  
        formData.append('file',file[i])
    }
      axios.post(`${baseUrl}/index/package/create`,formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then(res=>{
          if(res.data==="success"){
              setMessage("Package added successfully")
          }
          if(res.data==="failed"){
              setMessage("Something went wrong")
          }
      })
      .catch(err=>console.log(err))
    }
   
}
  return (
    <div className="container">
      <h2 className="text-center mt-5">Add new package</h2>
      <Link to='/admin/dashboard'>back</Link>
      <div className="row mt-3">
        <div className="col-6">
          <label htmlFor="packageName" className="form-label">
            Package Name
          </label>
          <input
            type="text"
            className="form-control"
            id="packageName"
            placeholder="Enter Package Name"
            onChange={(e) => setPackageName(e.target.value)}
          />
        </div>
        <div className="col-6">
          <label htmlFor="examName" className="form-label">
            Exam Name
          </label>
          <input
            type="text"
            className="form-control"
            id="examName"
            placeholder="Exam name"
            onChange={(e) => setExamName(e.target.value)}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <label htmlFor="paymentType" className="form-label">
            Payment Type
          </label>
          <input
            type="text"
            className="form-control"
            id="paymentType"
            placeholder="Payment Type"
            onChange={(e) => setPayment(e.target.value)}
          />
        </div>
        <div className="col-6">
          <label htmlFor="amount" className="form-label">
            Amount
          </label>
          <input
            type="number"
            className="form-control"
            id="amount"
            placeholder="amount"
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea onChange={(e)=>setDescription(e.target.value)} className="form-control" id="description"></textarea>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="image" className="form-label">
              Image
            </label>
            <input ref={imgRef} onChange={handleFile} type="file" className="form-control" />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="image" className="form-label px-2">
              Active
            </label>
            <input checked={active} onChange={()=>setActive(!active)} className="ml-2" type="checkbox" />
          </div>
        </div>
        {
                message&&
                <div
              className="alert alert-warning alert-dismissible fade show mt-3"
              role="alert"
            >
                {message}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
                onClick={()=>setMessage(false)}
              ></button>
            </div>
            }
        <button onClick={handleSubmit} className="btn btn-primary" style={{ width: "100px" }}>
          Create
        </button>
      </div>
    </div>
  );
};

export default CreatePackage;
